import http from "@/utils/http";

// 添加班级
export function addClass(data) {
  return http({
    url: "/class/add",
    method: "POST",
    data
  });
}
// 修改班级
export function updateClass(id, data) {
  return http({
    url: "/class/update/" + id,
    method: "POST",
    data
  });
}
// 删除/解散班级
export function removeClass(id) {
  return http({
    url: "/class/delete?classid=" + id,
    method: "POST"
  });
}

// 分页查询班级列表
export function getClass(data) {
  return http({
    url: "/classes",
    method: "GET",
    params: data,
  });
}

// 查询指定班级
export function getClassInfo(data) {
  return http({
    url: "/class/detail?classid=" + data,
    method: "GET"
  });
}
